import { Routes } from '@angular/router';

import { authorizationGuard } from './auth/guards/authorization.guard';
import { privatePagesGuard } from './auth/guards/private-pages.guard';
import { publicPagesGuard } from './auth/guards/public-pages.guard';
import { LoginComponent } from './auth/login/login.component';
import { baseDataGuard } from './shared/guards/base-data.guard';
import { RecoveryComponent } from './auth/recovery/recovery.component';
import { PrivacyPolicyComponent } from './left-menu-pages/privacy-policy/privacy-policy.component';

export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'orders' },
  {
    path: '',
    children: [
      {
        path: '',
        canActivateChild: [publicPagesGuard],
        children: [
          {
            path: 'login',
            component: LoginComponent,
          },
          {
            path: 'recovery',
            component: RecoveryComponent,
          },
          {
            path: 'privacy-policy',
            component: PrivacyPolicyComponent,
          },
        ],
      },
      
      {
        path: '',
        canActivateChild: [privatePagesGuard],
        children: [
          {
            path: '',
            canActivateChild: [authorizationGuard],
            children: [
              {
                path: '',
                canActivateChild: [baseDataGuard],
                children: [
                  {
                    path: '',
                    children: [
                      {
                        path: '',
                        // This component shows the menu and a loader in case of resolving the internally navigated section data
                        loadChildren: () => import('./left-menu-pages/left-menu-pages.routes'),
                      },
                      { path: '**', redirectTo: 'orders' },
                    ],
                  },
                  { path: '**', redirectTo: 'orders' },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
